/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import styled, {
  FlattenSimpleInterpolation,
  StyledComponent,
} from 'styled-components';

interface Props {
  private?: boolean;
}

export const withPrivacy = <
  C extends keyof JSX.IntrinsicElements | React.ComponentType<any>,
  T extends object,
  O extends object = {},
  A extends keyof any = never,
>(
  component: StyledComponent<C, T, O, A>,
  overrides: FlattenSimpleInterpolation,
): StyledComponent<C, T, O & Props, A> =>
  styled(component)`
    ${(props) => (props.private ? overrides : '')};
  ` as any;
